<template>
  <div class="OpenAccountContract">
    <div class="contractBox">
        <van-checkbox shape="square" @click="checkedAllHandler" checked-color="#ff6538" icon-size="14px" v-model="checkedAll">我已阅读并接受如下全部声明，协议及服务</van-checkbox>
        <div class="contractChild">
            <div class="personalAgreementBox">
              <van-checkbox v-model="checkedFirst" class="personalAgreementCheckbox" shape="square" checked-color="#ff6538" icon-size="14px"></van-checkbox>
              <span class="personalAgreementText" @click="handlerAgreementText">本人声明仅为中国税收居民，并充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒。承诺依法依规开立和使用本人账户。</span>
            </div>
            <van-checkbox v-model="checkedSecond" @click="forceReadList('checkedSecond')" shape="square" checked-color="#ff6538" icon-size="14px">我已阅读并接受：</van-checkbox>
            <div class="protocolList">
              <div @click="showClick('pufa_constitution')">1、《上海浦东发展银行借记卡章程》</div>
              <div @click="showClick('pufa_debitcard')">2、《上海浦东发展银行借记卡服务协议》</div>
              <div @click="showClick('pufa_account')">3、《开户须知》</div>
              <div @click="showClick('pufa_privacy')">4、《上海浦东发展银行电子银行个人客户服务协议及隐私协议》</div>
              <div @click="showClick('pufa_service')">5、《上海浦东发展银行个人电子账户产品服务协议》</div>
            </div>
            <van-checkbox v-model="checkedThird" shape="square" checked-color="#ff6538" icon-size="14px">我已阅读并接受<span class="text" @click="showClick('information_service')">《资讯服务》</span>（可选）</van-checkbox>
        </div>
      </div>
      <van-popup
        v-model="show"
        round
        class="inPop"
      >
        <component
          :is="contract"
          :hidePopup="hidePopup"
        ></component>
        <div @click="forceReadSure" v-if="forceRead" class="forceReadBtn" :class="forceReadText !== '我已阅读' ? 'disable' : ''">{{forceReadText}}</div>
      </van-popup>
  </div>
</template>

<script>
import pufaPrivacyAgreement from '@/components/FeildTwo/components/pufaPrivacyAgreement.vue'; //4
import pufaServiceAgreement from '@/components/FeildTwo/components/pufaServiceAgreement.vue'; //5
import pufaAccountAgreement from '@/components/FeildTwo/components/pufaAccountAgreement.vue'; //3
import informationAgreement from '@/components/FeildTwo/components/informationAgreement.vue';
import pufaConstitutionAgreement from '@/components/FeildTwo/components/pufaConstitutionAgreement.vue'; //1
import pufadebitcardAgreement from '@/components/FeildTwo/components/pufadebitcardAgreement.vue'; //2
import ForceReadOpenAccount from '@/components/ForceRead/ForceReadOpenAccount.vue';
var clearIv = null;
export default {
  name: 'OpenAccountContract',
  data() {
    return {
      count: 5,
      forceReadText: ``,
      forceRead: false,
      forceType: '',

      checkedAll: false,
      checkedFirst: false,
      checkedSecond: false,
      checkedThird: false,
      show: false,
      contract: 'pufaPrivacyAgreement',
    };
  },
  components: {
    pufaPrivacyAgreement,
    pufaServiceAgreement,
    pufaAccountAgreement,
    informationAgreement,
    pufaConstitutionAgreement,
    pufadebitcardAgreement,
    ForceReadOpenAccount,
  },
  methods: {
    forceReadList(label) {
      this.forceType = label;
      this[label] = !this[label];

      if(!this.forceRead && !this[label]) {
        this.showClick('ForceReadOpenAccount');
        this.count = 5;
        this.forceRead = true;
        this.show = true;
        this.forceReadText = `我已阅读(${this.count--})`;
        clearIv = setInterval(() => {
          if(this.count > 0) {
            this.forceReadText = `我已阅读(${this.count--})`;
          } else {
            this.forceReadText = `我已阅读`;
          }
        }, 1000)
      } else {
        this[label] = false;
        if(label === 'checkedAll') {
          this.checkedFirst = false;
          this.checkedSecond = false;
          this.checkedThird = false;
        }
      }
    },
    forceReadSure() {
      if(this.forceReadText !== '我已阅读') return;
      clearInterval(clearIv);
      this.show = false;
      this.forceRead = false;
      this[this.forceType] = true;

      if(this.forceType === 'checkedAll') {
        this.checkedFirst = this.checkedAll;
        this.checkedSecond = this.checkedAll;
        this.checkedThird = this.checkedAll;
      }
    },
    checkedAllHandler() {
      this.forceReadList('checkedAll');
    },
    handlerAgreementText() {
      this.checkedFirst = !this.checkedFirst;
    },
    showClick(val) {
      const agreeMap = {
        pufa_privacy: 'pufaPrivacyAgreement',
        pufa_service: 'pufaServiceAgreement',
        pufa_constitution: 'pufaConstitutionAgreement',
        information_service: 'informationAgreement',
        pufa_debitcard: 'pufadebitcardAgreement',
        pufa_account: 'pufaAccountAgreement',
        ForceReadOpenAccount: 'ForceReadOpenAccount',
      };
      this.showPopup(agreeMap[val]);
    },
    showPopup(val) {
      this.contract = val;
      this.show = !this.show;
    },
    hidePopup() {
      this.show = !this.show;
    },
  },
  watch: {
    show: {
      handler() {
        if(!this.show) {
          this.forceRead = false;
          clearInterval(clearIv);
        }
      }
    },
    checkedFirst: {
      handler() {
        if (this.checkedFirst && this.checkedSecond && this.checkedThird) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
        if (this.checkedSecond && this.checkedFirst) {
          this.$emit('input', true);
        } else {
          this.$emit('input', false);
        }
      },
    },
    checkedSecond: {
      handler() {
        if (this.checkedFirst && this.checkedSecond && this.checkedThird) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
        if (this.checkedSecond && this.checkedFirst) {
          this.$emit('input', true);
        } else {
          this.$emit('input', false);
        }
      },
    },
    checkedThird: {
      handler() {
        console.log(this.checkedThird)
        if (this.checkedFirst && this.checkedSecond && this.checkedThird) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
        this.$emit('update:optionalFlag', this.checkedThird)
      },
    },
  },
};
</script>
<style scoped>
.base_color {
  padding-bottom: 40px;
}
.contractBox{
  padding: 15px;
  font-size: 12px;
}
.contractChild{
  padding-left: 20px;
  margin-top: 15px;
}
.personalAgreementText{
  display: block;
  width: 100%;
  text-align: left;
}
.personalAgreementBox{
  display: flex;
  justify-content: left;
  margin-bottom: 15px;
}
.personalAgreementCheckbox{
  width: 17px;
  height: 20px;
  margin-right: 7px;
}
.text{
  color: #ff6538;
}
.protocolList{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 15px;
  text-align: left;
}
.protocolList div{
  color: #ff6538;
  margin-bottom: 10px;
}
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}

.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  margin: 0 15px 0 15px;
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.seletedColor {
  color: #ff6538;
}
.agreementText {
  margin-left: 20px;
}
.forceReadBtn {
  position: absolute;
  width: 90%;
  bottom: 10px;
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
}
.disable {
  background: #d7d7d7;
}
</style>
